import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ListingMediaHelper = ({ className }: { className: string }) => {
  const { t } = useTranslation('app');

  return (
    <div
      className={`${className} w-full md:w-[266px] bg-orange_light_2 rounded-[12px] p-1.5x md:py-3x md:px-2x flex flex-col gap-1.5x md:gap-2x`}
    >
      <div className="flex gap-x">
        <Icon name="lamb" size="24px" className="text-orange" />
        <p className="text-orange_dark_2 text-link">{t('tipsForListing')}</p>
      </div>
      <div className="flex flex-col gap-x md:gap-1.5x">
        <p className="flex text-orange_dark_2 gap-x">
          <span className="w-[24px] text-center">•</span>
          <span className="text-caption md:text-body_2 flex-1">
            {' '}
            {t('mediaAlert1')}
          </span>
        </p>
        <p className="flex text-orange_dark_2 gap-x">
          <span className="w-[24px]  text-center">•</span>
          <span className="text-caption md:text-body_2 flex-1">
            {' '}
            {t('mediaAlert2')}
          </span>
        </p>
      </div>
    </div>
  );
};

export default ListingMediaHelper;
